import React, { useEffect, useState } from "react";
import styled from "styled-components";
import PrintBookRequestForm from "./BookRequestForm";

//#101522 --> Dark colour background
const ContactContainer = styled.div`
  margin: 0 auto;
  padding: 20px;
  background-color: ${(props) =>
    props.orgidmain === 2074 ? "#f9fbfd" : "#101522"};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  font-family: "Source Sans Pro", sans-serif;
`;

const PrintBookRequest = () => {
  //const [data, setdata] = useState([]);
  const [orgidmain, setorgidmain] = useState(null);
 
  const GetImageData = async (orgId) => {
    const sendData2 = {
      OrgId: Number(orgId),
    };

    //console.log(sendData2);

    try {
      const response = await fetch(
        `https://zaingielatestapi.azurewebsites.net/api/Main/GetOrganizationInfo`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(sendData2),
        }
      );

      const data = await response.json();

      //console.log(data);
      // Convert strings to booleans (supports array or object)

      //setdata(data);
    } catch (error) {
      console.error("Fetch failed:", error);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const sendData2 = {
        ActualWebsite: window.location.hostname,
        OrgName: "test",
      };

      try {
        await fetch(
          `https://zaingielatestapi.azurewebsites.net/api/FLOW/Getorgiddynamic`,
          {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify(sendData2),
          }
        )
          .then((response) => response.json())
          .then((data) => {
            const orgid = data.orgId;
            setorgidmain(orgid);
            GetImageData(orgid);
          });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  return (
    <ContactContainer orgidmain={orgidmain}>
      <center>
        <h2
          style={{
            color: `${orgidmain === 2074 ? "#101522" : "#fff"}`,
            fontFamily: "cursive",
            marginBottom: 50,
          }}
        >
        The Printed Copy Of The Book Costs Approximately Rs. 800/- or $10/- per copy.
        </h2>
      </center>

      <PrintBookRequestForm orgid={orgidmain} />
    </ContactContainer>
  );
};

export default PrintBookRequest;
